import React, { Component } from 'react';
import * as dayjsLocale from 'dayjs/locale/en-gb';
import * as antdLocale from 'antd/lib/locale/en_GB';
import {
  Scheduler,
  SchedulerData,
  ViewType,
  wrapperFun,
} from 'react-big-schedule';
import 'react-big-schedule/dist/css/style.css';
import api from '../../services/api';
import dayjs from 'dayjs';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
  Alert,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  IconButton,
} from '@mui/material';
import { SlidingPaneAddNew } from '../../components/Page/SlidingPaneAddNew';
import { guideHaveTime } from '../../schema/guideHaveTime';
import moment from 'moment';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { styled } from '@mui/material/styles';

class Basic extends Component {
  constructor(props) {
    super(props);

    const today = moment().format('YYYY-MM-DD');

    let schedulerData = new SchedulerData(today, ViewType.Week, false, false, {
      eventItemPopoverTrigger: null,
      schedulerContentHeight: '100%',
      resourceName: 'Staff',
      views: [
        {
          viewName: 'Day',
          viewType: ViewType.Day,
          showAgenda: false,
          isEventPerspective: false,
        },
        {
          viewName: 'Week',
          viewType: ViewType.Week,
          showAgenda: false,
          isEventPerspective: false,
        },
        {
          viewName: 'Month',
          viewType: ViewType.Month,
          showAgenda: false,
          isEventPerspective: false,
        },
      ],
    });

    schedulerData.setSchedulerLocale(dayjsLocale);
    schedulerData.setCalendarPopoverLocale(antdLocale);

    this.state = {
      viewModel: schedulerData,
      filterStaff: [],
      editEvent: null, // Store the event being edited
      editStart: '', // Store the new start date
      editEnd: '', // Store the new end date
      isDialogOpen: false, // Dialog open state
      isDeleteDialogOpen: false, // Dialog open state
      isNewDialogOpen: false, // Dialog open state
      selectedOption: '',
    };
  }

  componentDidMount() {
    this.loadSchedulerData();
    this.loadFilterStaffData();
  }

  loadFilterStaffData = () => {
    const searchParams = new URLSearchParams({});
    api
      .get('/admin/event-staff', searchParams)
      .then((response) => {
        this.setState({ ...this.state, ['filterStaff']: response });
      })
      .catch((error) => {
        console.error('Error loading staff data', error);
      });
  };

  loadSchedulerData = (selectedOption) => {
    const { viewModel } = this.state;

    const viewType = viewModel.viewType;
    const startDate = dayjs(viewModel.startDate, 'YYYY-MM-DD').format(
      'YYYY-MM-DD'
    );
    const endDate = dayjs(viewModel.endDate, 'YYYY-MM-DD').format('YYYY-MM-DD');

    const searchParams = new URLSearchParams({
      from: startDate,
      to: endDate,
      view_type: viewType,
      user_type: selectedOption ? selectedOption : '',
    });

    api
      .get('/scheduler-data', searchParams)
      .then((response) => {
        viewModel.setResources(response?.resources);
        viewModel.setEvents(response?.events);

        console.log(response?.events);

        this.setState({ viewModel });
      })
      .catch((error) => {
        console.error('Error loading scheduler data', error);
      });
  };

  handleEditEvent = (schedulerData, event) => {
    this.setState({
      editEvent: event,
      editStart: dayjs(event.start).format('YYYY-MM-DDTHH:mm'), // format for input type="datetime-local"
      editEnd: dayjs(event.end).format('YYYY-MM-DDTHH:mm'), // format for input type="datetime-local"
      isDialogOpen: true, // Open the dialog
    });
  };
  handleDeleteEvent = (schedulerData, event) => {
    this.setState({
      editEvent: event,
      editStart: dayjs(event.start).format('YYYY-MM-DDTHH:mm'), // format for input type="datetime-local"
      editEnd: dayjs(event.end).format('YYYY-MM-DDTHH:mm'), // format for input type="datetime-local"
      isDeleteDialogOpen: true, // Open the dialog
    });
  };

  handleAddEvent = (
    schedulerData,
    slotId,
    slotName,
    start,
    end,
    type,
    item
  ) => {
    const adjustedEnd = this.adjustEndTime(start, end);

    this.setState({
      editEvent: {
        slotId: slotId,
        slotName: slotName,
        start: start,
        end: adjustedEnd,
        type: type,
        item: item,
      },
      editStart: dayjs(start).format('YYYY-MM-DD HH:mm:ss'),
      editEnd: dayjs(adjustedEnd).format('YYYY-MM-DD HH:mm:ss'),
      isNewDialogOpen: true,
    });
  };

  adjustEndTime = (start, end) => {
    if (dayjs(end).hour() === 23 && dayjs(end).minute() === 59) {
      return dayjs(end)
        .add(1, 'day')
        .hour(dayjs(start).hour())
        .minute(dayjs(start).minute());
    }
    return end;
  };

  handleChangeStart = (e) => {
    this.setState({ editStart: e.target.value });
  };

  handleChangeEnd = (e) => {
    this.setState({ editEnd: e.target.value });
  };

  handleSave = () => {
    const { viewModel, editEvent, editStart, editEnd } = this.state;
    if (editEvent) {
      editEvent.start = dayjs(editStart);
      editEvent.end = dayjs(editEnd);
      editEvent.title = `${dayjs(editStart).format('HH:mm')}-${dayjs(
        editEnd
      ).format('HH:mm')}`;

      api
        .patch(`/scheduler-data/${editEvent?.id}`, {
          from: dayjs(editEvent.start).format('YYYY-MM-DD HH:mm:ss'),
          to: dayjs(editEvent.end).format('YYYY-MM-DD HH:mm:ss'),
        })
        .then((response) => {})
        .catch((error) => {
          console.error('Error loading scheduler data', error);
        });

      viewModel.updateEventStart(editEvent, editEvent.start);
      viewModel.updateEventEnd(editEvent, editEvent.end);
      this.setState({ viewModel, editEvent: null, isDialogOpen: false });
    }
  };

  handleDelete = () => {
    const { viewModel, editEvent, editStart, editEnd } = this.state;
    if (editEvent) {
      api
        .delete(`/scheduler-data/${editEvent?.id}`, {})
        .then((response) => {
          viewModel.updateEventStart(editEvent, editEvent.start);
          viewModel.updateEventEnd(editEvent, editEvent.end);

          this.loadSchedulerData();

          this.setState({
            viewModel,
            editEvent: null,
            isDeleteDialogOpen: false,
          });
        })
        .catch((error) => {
          console.error('Error delete scheduler data', error);
        });
    }
  };

  handleAddSave = (value) => {
    if (!value) {
      return false;
    }

    const { viewModel, editEvent } = this.state;
    if (editEvent) {
      value.map((item) => {
        let newEvent = {
          id: item.id,
          title: item.title,
          start: dayjs(item.start),
          end: dayjs(item.end),
          resourceId: editEvent.slotId,
          bgColor: 'purple',
        };
        viewModel.addEvent(newEvent);
      });
      this.setState({ viewModel, editEvent: null, isNewDialogOpen: false });
    }
    return true;
  };

  handleClose = () => {
    this.setState({ isDialogOpen: false });
  };
  handleDeleteClose = () => {
    this.setState({ isDeleteDialogOpen: false });
  };

  handleAddClose = () => {
    this.setState({ isNewDialogOpen: false });
  };

  handleSelectChange = (event) => {
    this.setState({ selectedOption: event.target.value });

    this.loadSchedulerData(event.target.value);

    // Handle logic based on selected option, such as filtering data
  };

  eventItemTemplateResolver = (
    schedulerData,
    event,
    bgColor,
    isStart,
    isEnd,
    mustAddCssClass,
    mustBeHeight,
    agendaMaxEventWidth
  ) => {
    const eventStart = new Date(event.start);
    const eventEnd = new Date(event.end);
    const cellWidth = schedulerData.getContentCellWidth();

    let borderWidth = isStart ? '4px' : '0';
    let borderColor = 'rgba(0,139,236,1)',
      backgroundColor = '#80C5F6';
    let titleText = schedulerData.behaviors.getEventTextFunc(
      schedulerData,
      event
    );

    const cellStart = new Date(event.start);
    cellStart.setHours(0, 0, 0, 0);

    let minutesFromStartOfDay = (eventStart - cellStart) / (1000 * 60);
    let eventDurationMinutes = (eventEnd - eventStart) / (1000 * 60);

    let cellMinutes = 24 * 60; // Egy nap 1440 perce

    const visibleEndOfWeek = new Date(schedulerData.endDate);
    visibleEndOfWeek.setHours(23, 59, 59, 999); // Az utolsó látható nap vége

    const adjustedEventEnd =
      eventEnd > visibleEndOfWeek ? visibleEndOfWeek : eventEnd;
    const adjustedEventDurationMinutes =
      (adjustedEventEnd - eventStart) / (1000 * 60);

    let offsetPx = (minutesFromStartOfDay / cellMinutes) * cellWidth;
    let widthPx =
      Math.round((adjustedEventDurationMinutes / cellMinutes) * cellWidth) - 5;

    if (schedulerData.viewType === 0) {
      minutesFromStartOfDay =
        eventStart.getHours() * 60 + eventStart.getMinutes();
      eventDurationMinutes = (eventEnd - eventStart) / (1000 * 60);

      offsetPx = (minutesFromStartOfDay / cellMinutes) * cellWidth;
      widthPx = Math.round(eventDurationMinutes);

      console.log(eventDurationMinutes, cellMinutes, cellWidth);
      console.log(offsetPx, widthPx);
    }

    let divStyle = {
      borderLeft: borderWidth + ' solid ' + borderColor,
      backgroundColor: backgroundColor,
      height: mustBeHeight,
      position: 'absolute',
      left: `${offsetPx}px`,
      width: `${widthPx}px`,

      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    };

    if (!!event.type) {
      divStyle = {
        ...divStyle,
        borderRadius: '10px',
        border: '2px solid ' + borderColor,
      };
    }

    const HtmlTooltip = styled(({ className, ...props }) => (
      <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
      [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
        paddingX: '20px',
        paddingY: '10px',
      },
    }));

    return (
      <HtmlTooltip
        title={
          <React.Fragment>
            <Stack direction={'row'} alignItems={'center'} gap={1}>
              <Stack direction={'row'} alignItems={'center'} gap={1}>
                <Typography
                  variant={'caption'}
                  sx={{
                    color: '#666',
                  }}
                >
                  {event?.start_month} {event?.start_day}
                </Typography>
                <Typography
                  variant={'h5'}
                  sx={{
                    color: '#80c5f6',
                  }}
                >
                  {event?.start_time}
                </Typography>
              </Stack>
              <Typography variant={'caption'} color="inherit">
                -
              </Typography>
              <Stack direction={'row'} alignItems={'center'} gap={1}>
                <Typography
                  variant={'caption'}
                  sx={{
                    color: '#666',
                  }}
                >
                  {event?.end_month} {event?.end_day}
                </Typography>
                <Typography
                  variant={'h5'}
                  sx={{
                    color: '#80c5f6',
                  }}
                >
                  {event?.end_time}
                </Typography>
              </Stack>
            </Stack>

            <Stack direction={'row'} gap={0} justifyContent={'flex-end'}>
              <IconButton
                onClick={() => {
                  this.handleDeleteEvent(schedulerData, event);
                }}
              >
                <DeleteIcon color={'error'} />
              </IconButton>
              <IconButton
                onClick={() => {
                  this.handleEditEvent(schedulerData, event);
                }}
              >
                <EditIcon color={'primary'} />
              </IconButton>
            </Stack>
          </React.Fragment>
        }
        placement="bottom-start"
      >
        <div key={event.id} className={mustAddCssClass} style={divStyle}>
          <span style={{ marginLeft: '4px', lineHeight: `${mustBeHeight}px` }}>
            {titleText}
          </span>
        </div>
      </HtmlTooltip>
    );
  };

  render() {
    const {
      viewModel,
      editStart,
      editEnd,
      editEvent,
      isDialogOpen,
      isDeleteDialogOpen,
      isNewDialogOpen,
      selectedOption,
      filterStaff,
    } = this.state;

    return (
      <div>
        <Stack
          gap={2}
          sx={{
            mt: '20px',
            flexDirection: {
              xs: 'column',
              md: 'row',
            },
          }}
        >
          <FormControl
            sx={{
              width: '300px',
            }}
          >
            <InputLabel id="select-label">Filter Staff</InputLabel>
            <Select
              labelId="select-label"
              value={selectedOption}
              label="Select Option"
              onChange={this.handleSelectChange}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {filterStaff.map((role) => {
                return (
                  <MenuItem value={role?.name}>{`${role?.name
                    .charAt(0)
                    .toUpperCase()}${role?.name.slice(1)}`}</MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <Alert
            severity="info"
            sx={{
              width: '100%',
            }}
          >
            <b>Guide: </b>
            <span>availability is marked</span>
            <br />
            <b>Artist: </b>
            <span>non-availability is marked</span>
          </Alert>
        </Stack>

        <Scheduler
          schedulerData={viewModel}
          prevClick={this.prevClick}
          nextClick={this.nextClick}
          onSelectDate={this.onSelectDate}
          onViewChange={this.onViewChange}
          viewEventClick={this.handleEditEvent}
          viewEventText="Edit"
          updateEventStart={this.updateEventStart}
          updateEventEnd={this.updateEventEnd}
          moveEvent={this.moveEvent}
          newEvent={this.handleAddEvent}
          onScrollLeft={this.onScrollLeft}
          onScrollRight={this.onScrollRight}
          onScrollTop={this.onScrollTop}
          onScrollBottom={this.onScrollBottom}
          toggleExpandFunc={this.toggleExpandFunc}
          eventItemTemplateResolver={this.eventItemTemplateResolver}
          eventItemPopoverTemplateResolver={
            this.eventItemPopoverTemplateResolver
          }
        />
        <Dialog
          open={isDialogOpen}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Edit Event</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Modify the start and end date/time of the event.
            </DialogContentText>
            <TextField
              margin="dense"
              label="Start"
              type="datetime-local"
              fullWidth
              value={editStart}
              onChange={this.handleChangeStart}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              margin="dense"
              label="End"
              type="datetime-local"
              fullWidth
              value={editEnd}
              onChange={this.handleChangeEnd}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSave} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isDeleteDialogOpen}
          onClose={this.handleDeleteClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Delete Event</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete it?
            </DialogContentText>
            {/*   <TextField
                            disabled={true}
                            margin="dense"
                            label="Start"
                            type="datetime-local"
                            fullWidth
                            value={editStart}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField
                            disabled={true}
                            margin="dense"
                            label="End"
                            type="datetime-local"
                            fullWidth
                            value={editEnd}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />*/}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDeleteClose} color={'primary'}>
              Cancel
            </Button>
            <Button
              variant={'contained'}
              onClick={this.handleDelete}
              color="error"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        {isNewDialogOpen && (
          <SlidingPaneAddNew
            schema={guideHaveTime}
            id={'new'}
            hasSlidingPane={false}
            onSubmit={(result) => {
              this.loadSchedulerData(selectedOption);
              this.handleAddClose();
              return true;
            }}
            propertiesFromTable={{
              from: editStart,
              to: editEnd,
              user: {
                id: editEvent?.slotId,
                name: editEvent?.slotName,
              },
            }}
            row={{}}
            onClose={(value) => {
              if (!value) {
                this.handleAddClose();
                return true;
              }

              this.handleAddSave(value);
              return true;
            }}
          />
        )}
      </div>
    );
  }

  prevClick = (schedulerData) => {
    schedulerData.prev();
    this.loadSchedulerData();
  };

  nextClick = (schedulerData) => {
    schedulerData.next();
    this.loadSchedulerData();
  };

  onViewChange = (schedulerData, view) => {
    schedulerData.setViewType(
      view.viewType,
      view.showAgenda,
      view.isEventPerspective
    );
    this.loadSchedulerData();
  };

  onSelectDate = (schedulerData, date) => {
    schedulerData.setDate(date);
    this.loadSchedulerData();
  };

  updateEventStart = (schedulerData, event, newStart) => {
    schedulerData.updateEventStart(event, newStart);
    this.setState({ viewModel: schedulerData });
  };

  updateEventEnd = (schedulerData, event, newEnd) => {
    schedulerData.updateEventEnd(event, newEnd);
    this.setState({ viewModel: schedulerData });
  };

  moveEvent = (schedulerData, event, slotId, slotName, start, end) => {
    schedulerData.moveEvent(event, slotId, slotName, start, end);
    this.setState({ viewModel: schedulerData });
  };

  onScrollRight = (schedulerData, schedulerContent, maxScrollLeft) => {
    if (schedulerData.ViewTypes === ViewType.Day) {
      schedulerData.next();
      this.loadSchedulerData();
      schedulerContent.scrollLeft = maxScrollLeft - 10;
    }
  };

  onScrollLeft = (schedulerData, schedulerContent) => {
    if (schedulerData.ViewTypes === ViewType.Day) {
      schedulerData.prev();
      this.loadSchedulerData();
      schedulerContent.scrollLeft = 10;
    }
  };

  onScrollTop = () => console.log('onScrollTop');

  onScrollBottom = () => console.log('onScrollBottom');

  toggleExpandFunc = (schedulerData, slotId) => {
    schedulerData.toggleExpandStatus(slotId);
    this.setState({ viewModel: schedulerData });
  };
}

export default wrapperFun(Basic);
